import React from "react";
import {
  MDBSpinner,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBChip,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBIcon, MDBCol, MDBRow, MDBInput
} from 'mdbreact';
import StorageLink from './StorageLink'
import firebase from "../../firebase";
import { getTypesenseClient } from "../../utils/typesenseClient";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import DatePicker from "react-datepicker";

class Estimates2TableList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dbEstimates2s: [],
      last: null,
      estimates2PerPage: 12,
      searchwordA: '',
      algoriaPage: 1,
      algolia: false,
      sortType: 'desc',
      estimates2sType: '1',
      selectedEstimatesList: [],
      downloading: false,
      downloadingAll: false,
      sortMainType: 'dueDate',
      sellerUsers: [],
      buyerUsers: [],
      sentDateStart: null,
      sentDateEnd: null,
      confirmDateStart: null,
      confirmDateEnd: null,
      issueDateStart: null,
      issueDateEnd: null,
      endDateStart: null,
      endDateEnd: null,
      estimateNo: '',
      estimateId: '',
      title: '',
      sender: '',
      receiver: '',
      confirmer: '',
      filterType: 'estimateNo',
      searchAmount: '',
      searchAmountEnd: '',
    }
  }

  getEstimates2sA = async (props, newOrg, word) => {
    if (this.state.loading) {
      return;
    }

    let fromOrg = "";
    let toOrg = "";
    let urigawa = false;
    let indexName = 'P4Estimates2';

    if(props.userOrg && props.userOrg.reseller && props.org && props.org.buyer) {
      fromOrg = this.props.userOrg?.id;
      toOrg = props.org.id;
      urigawa = true;
    }
    if(props.userOrg && props.userOrg.maker && props.org && props.org.reseller) {
      fromOrg = this.props.userOrg?.id;
      toOrg = props.org.id;
      urigawa = true;
    }
    if(props.userOrg && props.userOrg.reseller && props.org && props.org.maker) {
      fromOrg = props.org.id;
      toOrg = this.props.userOrg?.id;
    }
    if(props.userOrg && props.userOrg.buyer && props.org && props.org.reseller) {
      fromOrg = props.org.id;
      toOrg = this.props.userOrg?.id;
    }
    if (fromOrg == "" || toOrg == ""){
      return;
    }

    let tempResults = [];

    this.setState({loading: true, algolia: true});
    let filters = `fromOrganization:${fromOrg} && toOrganization:${toOrg}`
    let query_by = '*';
    let q = '*'
    let infix = 'off';
    if (!urigawa) {
      filters += ` && deleted:false`
    } else {
      switch (this.state.estimates2sType) {
        case '1':
          filters += ` && deleted:false`;
          break;
        case '2':
          filters += ` && deleted:true`;
          break;
      }
    }

    if (this.state.filterType === 'sentDate' && this.state.sentDateStart && this.state.sentDateEnd) {
      let startTimestamp = new Date(this.state.sentDateStart).getTime()/1000;
      let endTimestamp = new Date(this.state.sentDateEnd).setHours(23,59,59)/1000;
      console.log('sentDate search', startTimestamp, endTimestamp);
      filters += ` && created._seconds:[${startTimestamp}..${endTimestamp}]`;
    }
    if (this.state.filterType === 'confirmDate' && this.state.confirmDateStart && this.state.confirmDateEnd) {
      let startTimestamp = new Date(this.state.confirmDateStart).getTime()/1000;
      let endTimestamp = new Date(this.state.confirmDateEnd).setHours(23,59,59)/1000;
      console.log('confirmDate search', startTimestamp, endTimestamp);
      filters += ` && confirmDate._seconds:[${startTimestamp}..${endTimestamp}]`;
    }
    if (this.state.filterType === 'issueDate' && this.state.issueDateStart && this.state.issueDateEnd) {
      let startTimestamp = new Date(this.state.issueDateStart).getTime()/1000;
      let endTimestamp = new Date(this.state.issueDateEnd).setHours(23,59,59)/1000;
      console.log('issueDate search', startTimestamp, endTimestamp);
      filters += ` && date._seconds:[${startTimestamp}..${endTimestamp}]`;
    }
    if (this.state.filterType === 'endDate' && this.state.endDateStart && this.state.endDateEnd) {
      let startTimestamp = new Date(this.state.endDateStart).getTime()/1000;
      let endTimestamp = new Date(this.state.endDateEnd).setHours(23,59,59)/1000;
      console.log('endDate search', startTimestamp, endTimestamp);
      filters += ` && expireDate._seconds:[${startTimestamp}..${endTimestamp}]`;
    }
    if (this.state.filterType === 'amount' && this.state.searchAmount && this.state.searchAmountEnd) {
      filters += ` && totalAmount:[${this.state.searchAmount}..${this.state.searchAmountEnd}]`;
    }
    if (this.state.filterType === 'estimateNo' && this.state.estimateNo) {
      q = `${this.state.estimateNo}`
      query_by = 'number';
      infix = 'always';
    }
    if (this.state.filterType === 'estimateId' && this.state.estimateId) {
      q = `${this.state.estimateId}`
      //filters += ` && objectID:'${this.state.estimateId}'`;
      query_by = 'objectID';
      infix = 'always'
    }
    if (this.state.filterType === 'title' && this.state.title) {
      //filters += ` && title:'${this.state.title}'`;
      q = `${this.state.title}`
      query_by = 'title';
      infix = 'always';
    }
    if (this.state.filterType === 'sender' && this.state.sender) {
      filters += ` && fromUser:${this.state.sender}`;
    }
    if (this.state.filterType === 'receiver' && this.state.receiver) {
      filters += ` && toUser:${this.state.receiver}`;
    }
    if (this.state.filterType === 'confirmer' && this.state.confirmer) {
      filters += ` && confirmUser:${this.state.confirmer}`;
    }
    let orderBy = 'dueDate';
    if (this.state.sortMainType === 'endDate') {
      orderBy = 'expireDate._seconds';
    }
    if (this.state.sortMainType === 'created') {
      orderBy = 'created._seconds';
    }
    console.log('filters', filters);

    let searchParameters = {
      'q'         : q,
      'query_by'  : query_by,
      'infix'     : infix,
      "num_typos": 0,
      "typo_tokens_threshold": 0,
      'filter_by' : filters,
      'sort_by'   : `${orderBy}:${this.state.sortType}`,
      'page'      : this.state.algoriaPage,
      'per_page'  : this.state.estimates2PerPage
    }
    try {
      await (await getTypesenseClient()).collections('estimates2').documents().search(searchParameters).then((docs) => {
        docs.hits.forEach((data) => {
          tempResults.push(data.document);
        })
      });
    } catch (e) {
      console.error('[typesense] estimates2 search failed', e);
      this.setState({ loading: false });
      return;
    }
    let nextPage = this.state.algoriaPage + 1;
    let newResults = this.state.dbEstimates2s.concat(tempResults);
    this.setState({algoriaPage: nextPage,dbEstimates2s:newResults,loading:false})
    /*if (this.state.sortType === 'desc') {
      indexName = 'P4Estimates2'
    } else {
      indexName = 'P4Estimates2_dueDate_asc'
    }

    await client.initIndex(indexName)
        .search( word, {
          page: this.state.algoriaPage,
          filters: filters
        })
        .then(function(responses) {
          tempResults = responses.hits;
        });

    let nextPage = this.state.algoriaPage + 1;
    let newResults = this.state.dbEstimates2s.concat(tempResults);

    this.setState({
      algoriaPage: nextPage,
      dbEstimates2s: newResults,
      loading: false
    });*/
  }

  getEstimates2s = (props, newOrg) => {
    if (this.state.loading) {
      return;
    }

    let fromOrg = "";
    let toOrg = "";
    let urigawa = false;

    if(props.userOrg && props.userOrg.reseller && props.org && props.org.buyer) {
      fromOrg = this.props.userOrg?.id;
      toOrg = props.org.id;
      urigawa = true;
    }
    if(props.userOrg && props.userOrg.maker && props.org && props.org.reseller) {
      fromOrg = this.props.userOrg?.id;
      toOrg = props.org.id;
      urigawa = true;
    }
    if(props.userOrg && props.userOrg.reseller && props.org && props.org.maker) {
      fromOrg = props.org.id;
      toOrg = this.props.userOrg?.id;
    }
    if(props.userOrg && props.userOrg.buyer && props.org && props.org.reseller) {
      fromOrg = props.org.id;
      toOrg = this.props.userOrg?.id;
    }
    if (fromOrg == "" || toOrg == ""){
      return;
    }

    // let s = this.props.db.collection('estimates2').orderBy('created', 'desc');
    // s.get().then((snapshot) => {
    //   console.log(snapshot.docs.length);
    //   snapshot.forEach((doc) => {
    //     let data = doc.data();
    //     // console.log(data)
    //     if (data.deleted && data.deleted !== true) {
    //       console.log('deleted true',data);
    //       this.props.db.collection('estimates2').doc(doc.id).update({deleted: true});
    //     }
    //
    //     if (!data.deleted && data.deleted !== false) {
    //       console.log('deleted false',data)
    //       this.props.db.collection('estimates2').doc(doc.id).update({deleted: false});
    //     }
    //   })
    // });

    let first;
    this.setState({loading: true, algolia: false})

    if (urigawa) {
      switch (this.state.estimates2sType) {
        case '1':
          if(this.state.last){
            first = this.props.db.collection('estimates2')
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where(this.state.sortMainType, "!=" , 0)
                .where("deleted", "==", false)
                .orderBy(this.state.sortMainType,this.state.sortType)
                .startAfter(this.state.last)
                .limit(this.state.estimates2PerPage);
          }else{
            first = this.props.db.collection("estimates2")
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where(this.state.sortMainType, "!=" , 0)
                .where("deleted", "==", false)
                .orderBy(this.state.sortMainType,this.state.sortType)
                .limit(this.state.estimates2PerPage);
          }
          break;
        case '2':
          if(this.state.last){
            first = this.props.db.collection('estimates2')
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where(this.state.sortMainType, "!=" , 0)
                .where("deleted", "==", true)
                .orderBy(this.state.sortMainType,this.state.sortType)
                .startAfter(this.state.last)
                .limit(this.state.estimates2PerPage);
          }else{
            first = this.props.db.collection("estimates2")
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where(this.state.sortMainType, "!=" , 0)
                .where("deleted", "==", true)
                .orderBy(this.state.sortMainType,this.state.sortType)
                .limit(this.state.estimates2PerPage);
          }
          break;
        default:
          if(this.state.last){
            first = this.props.db.collection('estimates2')
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where(this.state.sortMainType, "!=" , 0)
                .orderBy(this.state.sortMainType,this.state.sortType)
                .startAfter(this.state.last)
                .limit(this.state.estimates2PerPage);
          }else{
            first = this.props.db.collection("estimates2")
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where(this.state.sortMainType, "!=" , 0)
                .orderBy(this.state.sortMainType,this.state.sortType)
                .limit(this.state.estimates2PerPage);
          }
          break;
      }
    } else {
      if(this.state.last){
        first = this.props.db.collection('estimates2')
            .where("fromOrganization", "==", fromOrg)
            .where("toOrganization", "==", toOrg)
            .where("deleted", "==", false)
            .where(this.state.sortMainType, "!=" , 0)
            .orderBy(this.state.sortMainType,this.state.sortType)
            //.orderBy('titlekana','asc')
            .startAfter(this.state.last)
            .limit(this.state.estimates2PerPage);
      }else{
        first = this.props.db.collection("estimates2")
            .where("fromOrganization", "==", fromOrg)
            .where("toOrganization", "==", toOrg)
            .where("deleted", "==", false)
            .where(this.state.sortMainType, "!=" , 0)
            .orderBy(this.state.sortMainType,this.state.sortType)
            //.orderBy('titlekana','asc')
            .limit(this.state.estimates2PerPage);
      }
    }


    let paginate = first.get()
    .then((snapshot) => {
      this.setState({loading: false})
      if(snapshot.docs.length > 0) {
        let last = snapshot.docs[snapshot.docs.length - 1];

        this.setState({last: last})


        let estimates2s = this.state.dbEstimates2s;

        if (newOrg) {
          estimates2s = []
        }

        snapshot.forEach((doc) => {
          let data = doc.data();
          data.id = doc.id;
          estimates2s.push(data)
        })
        this.setState({dbEstimates2s: estimates2s}, () => {
          let wrapper1 = document.getElementById('wrapper1');
          let div1 = document.getElementById('div1');
          let wrapper2 = document.getElementsByClassName('table-responsive')[0];
          let div2 = document.getElementById('div2');

          if (wrapper1 && div1 && wrapper2 && div2) {
            div1.style.width = div2.offsetWidth+'px';

            wrapper1.onscroll = function() {
              wrapper2.scrollLeft = wrapper1.scrollLeft;
            };
            wrapper2.onscroll = function() {
              wrapper1.scrollLeft = wrapper2.scrollLeft;
            };
          }
        })
      }else{
        // if (newOrg === true) {
        //   this.setState({dbEstimates2s: []})
        // }
      }

    });

  }

  componentDidMount() {
    //this.getEstimates2s();
    this.getEstimates2s(this.props, true);
    this.getOrganizationUsers(this.props);
    this.props.loadBadge();
    window.addEventListener('scroll', event => this.watchCurrentPosition(), true);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({last: null, dbEstimates2s: []}, () => {
      this.getEstimates2s(nextProps, true);
      this.props.loadBadge();
    })
    this.getOrganizationUsers(nextProps);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', event => this.watchCurrentPosition(), true);
  }
  getOrganizationUsers = (props) => {
    let sellerUsers = [];
    let buyerUsers = [];

    // console.log('props', props);

    if(props.userOrg && props.userOrg.reseller && props.org && props.org.buyer) {
      // console.log('seller', props);
      sellerUsers = props.userOrg.users;
      buyerUsers = props.org.users;
    }
    if(props.userOrg && props.userOrg.maker && props.org && props.org.reseller) {
      // console.log('seller', props);
      sellerUsers = props.userOrg.users;
      buyerUsers = props.org.users;
    }
    if(props.userOrg && props.userOrg.reseller && props.org && props.org.maker) {
      // console.log('buyer', props);
      sellerUsers = props.org.users;
      buyerUsers = props.userOrg.users;
    }
    if(props.userOrg && props.userOrg.buyer && props.org && props.org.reseller) {
      // console.log('buyer', props);
      sellerUsers = props.org.users;
      buyerUsers = props.userOrg.users;
    }

    if (sellerUsers.length > 0 && buyerUsers.length > 0) {
      // console.log(sellerUsers, buyerUsers);
      this.setState({
        sellerUsers,
        buyerUsers
      })
    }
  }
  watchCurrentPosition() {
    if(window.innerHeight + this.scrollTop() +20 >= document.body.clientHeight) {
      console.log('reach end');
      this.onReachEnd();
    }
  }

  scrollTop() {
    return Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
        );
  }

  onReachEnd = () => {
    console.log("LAST:" , this.state.last);
    if(this.state.algolia){
      this.getEstimates2sA(this.props, false, this.state.searchwordA);
    } else {
      this.getEstimates2s(this.props, false);
    }
  }

  openFile = (e) => {
    console.log("openFile:" , e.currentTarget.dataset.id);

    let esId = e.currentTarget.dataset.id;
    let urigawa = e.currentTarget.dataset.urigawa;
    let index = e.currentTarget.dataset.index;
    urigawa = urigawa === 'true'

    let item = this.state.dbEstimates2s[index];

    let billSet = {
      visited: {[this.props.user.id]: true},
    }
    if (!urigawa) {
      let date = firebase.firestore.Timestamp.fromDate(new Date())

      if (!item.confirmDate && !(item['visited'] && item['visited'][item['toUser']])) {
        billSet.confirmDate = date
        billSet.confirmUser = this.props.user.id;
        billSet.confirmUserName = this.props.user.last_name + this.props.user.first_name;
        this.dbEstimates2Update(esId,"confirmDate",date);
        this.dbEstimates2Update(esId,"confirmUserName",this.props.user.last_name + this.props.user.first_name);
      }

      if (item.readBuyer === false) {
        billSet.readBuyer = true;
        this.dbEstimates2Update(esId,"readBuyer",true);
        this.props.readEstimates2(1)
      }

    } else {
      if (item.readSeller === false) {
        billSet.readSeller = true;
        this.dbEstimates2Update(esId,"readSeller",true);
        this.props.readEstimates2(1)
      }

    }

    let billsRef = this.props.db.collection('estimates2').doc(esId);
    billsRef.set(billSet, { merge: true });
    this.dbEstimates2Update(esId,"visited",{[this.props.user.id]:true});
  }

  delete = (e) => {
    let esId = e.currentTarget.dataset.id;
    let esTitle = e.currentTarget.dataset.title;

    this.setState({
      deleteModal: true,
      deleteId: esId,
      deleteTitle: esTitle,
    })
  }

  deleteClose = (e) => {
    this.setState({
      deleteModal: false,
      deleteId: null,
      deleteTitle: null,
    });

    let esId = e && e.currentTarget.dataset.id;
    if(esId){
      let date = firebase.firestore.Timestamp.fromDate(new Date())

      let billsRef = this.props.db.collection('estimates2').doc(esId);
      billsRef.set({
        deleted: true,
        deletedUser: this.props.user.id,
        deletedUserName: this.props.user.last_name + this.props.user.first_name,
        deletedDate: date
      }, { merge: true });
      this.dbEstimates2Update(esId,"deleted",{key:1});
    }
  }

  dbEstimates2Update = (id,target,value) => {
    let dbEstimates2Updated = this.state.dbEstimates2s.map((es)=>{
      if(es.id === id){
        if(target === 'visited') {
          let visited = es.visited;
          if(visited){
            es[target] = Object.assign(visited, value);
          } else {
            es[target] = value;
          }
        }else{
          es[target] = value;
        }
      }
      return es;
    })
    this.setState({
      dbEstimates2s: dbEstimates2Updated,
    })
  }

  handleSearchwordAChange = (e) => {
    this.setState({
      searchwordA: e.currentTarget.value,
    });
  }

  handleSearchwordAKeyDown = (e) => {
    let val = this.state.searchwordA;
    if (e.key === 'Enter') {
      this.setState({
        dbEstimates2s: [],
        last: null,
        algoriaPage: 1,selectedEstimatesList: []
      }, ()=>{
        if (val) {
          this.getEstimates2sA(this.props, true, val);
        } else {
          this.getEstimates2s(this.props, true)
        }

      });
    }
  }

  sortChange = (val) => {
    this.setState({last: null, notMore: false, sortType: val, dbEstimates2s: [], algoriaPage: 1,selectedEstimatesList: []}, () => {
      if (this.state.algolia) {
        this.getEstimates2sA(this.props, true, this.state.searchwordA);
      } else {
        this.getEstimates2s(this.props, true);
      }
    })
  }

  selectEstimates2sType = (e) => {
    this.setState({
      estimates2sType: e.target.value || '1',
      last: null,
      notMore: false,
      dbEstimates2s: [],
      algoriaPage: 1,selectedEstimatesList: []
    }, () => {
      if (this.state.algolia) {
        this.getEstimates2sA(this.props, true, this.state.searchwordA);
      } else {
        this.getEstimates2s(this.props, true);
      }
    });
  }

  clearFilter = () => {
    this.setState({
      downloading: false,
      downloadingAll: false,
      sortMainType: 'dueDate',
      sentDateStart: null,
      sentDateEnd: null,
      confirmDateStart: null,
      confirmDateEnd: null,
      issueDateStart: null,
      issueDateEnd: null,
      endDateStart: null,
      endDateEnd: null,
      estimateNo: '',
      estimateId: '',
      title: '',
      sender: '',
      receiver: '',
      confirmer: '',
      filterType: 'estimateNo',
      searchAmount: '',
      searchAmountEnd: '',
      searchwordA: '',
      notMore: false,
      sortType: 'desc',
      estimates2sType: '1',
      last: null,
      dbEstimates2s: [],
      algolia: false,
      algoriaPage: 1,selectedEstimatesList: []
    }, () => {
      if (this.state.algolia) {
        this.getEstimates2sA(this.props, true, this.state.searchwordA);
      } else {
        this.getEstimates2s(this.props, true);
      }
    });
  }


  estimatesIsSelected = (docId) => {
    let filtered = this.state.selectedEstimatesList.filter(item => {
      if (item.objectID) {
        return item.objectID === docId
      } else {
        return item.id === docId
      }

    });
    return filtered.length > 0
  };

  estimatesSelect = (selected, data) => {
    let selectedList;
    if (selected) {
      selectedList = [...this.state.selectedEstimatesList, data];
    } else {
      selectedList = this.state.selectedEstimatesList.filter( est => {
        if (est.objectID) {
          return est.objectID !== data.objectID
        } else {
          return est.id !== data.id
        }
      });
    }

    this.setState({
      selectedEstimatesList: selectedList
    })
  }

  estimatesSelectAll = (selected) => {
    let selectedList = [];
    if (selected === true) {
      this.state.dbEstimates2s.forEach((data,index) => {
        selectedList.push(data);
      });
      this.setState({
        selectedEstimatesList: selectedList
      }, () => {
      })
    } else {
      this.setState({
        selectedEstimatesList: selectedList
      });
    }
  };

  formatDate = (date = new Date())=> {
    const year = date.toLocaleString('jp', {year: 'numeric'});
    const month = date.toLocaleString('jp', {
      month: '2-digit',
    });
    const day = date.toLocaleString('jp', {day: '2-digit'});
    const hour = date.toLocaleString('jp', {hour: '2-digit'});
    const min = date.toLocaleString('jp', {minute: '2-digit'});
    const second = date.toLocaleString('jp', {second: '2-digit'});
    let dateFormatted = year + '-'+ month + '-' + day + ' ' + hour.substring(0,2) + '' + (min * 1 < 10 ? '0'+'' + min : min) + '' + (second * 1 < 10 ? '0'+'' + second : second);
    return dateFormatted
  }

  downloadSelectedEstimates = async () => {
    this.setState({downloading: true})

    const jszip = new JSZip();

    let promises = this.state.selectedEstimatesList.map( async (data) => {
      if (data && data.file) {
        const fileBlob = await this.props.storage.ref(data.file).getDownloadURL().then( (url) => {
          return fetch(url).then((response) => response.blob());
        })
        const fileName = data.file.split('/').pop();
        jszip.file(fileName, fileBlob);
      }
    }).reduce((acc, curr) => acc.then(() => curr), Promise.resolve());
    await promises;
    const blob = await jszip.generateAsync({ type: 'blob' });
    //console.log('jszip', jszip)
    let date = new Date();
    let dateFormatted = this.formatDate(date);
    saveAs(blob, 'Estimates2_'+dateFormatted+'.zip');
    this.setState({downloading: false})
  }


  handleChange = (e,type) => {
    console.log('handleChange e,type',e,type);
    switch (type) {
      case 'sender':
        this.setState({
          sender: e.target.value || ''
        })
        break;
      case 'receiver':
        this.setState({
          receiver: e.target.value || ''
        })
        break;
      case 'confirmer':
        this.setState({
          confirmer: e.target.value || ''
        })
        break;
      case 'estimateId':
        this.setState({
          estimateId: e.currentTarget.value || ''
        })
        break;
      case 'title':
        this.setState({
          title: e.currentTarget.value || ''
        })
        break;
      case 'estimateNo':
        this.setState({
          estimateNo: e.currentTarget.value || ''
        })
        break;

      case 'sentDateStart':
        this.setState({
          sentDateStart: e
        })
        break;
      case 'sentDateEnd':
        this.setState({
          sentDateEnd: e
        })
        break;
      case 'confirmDateStart':
        this.setState({
          confirmDateStart: e
        })
        break;
      case 'confirmDateEnd':
        this.setState({
          confirmDateEnd: e
        })
        break;
      case 'issueDateStart':
        this.setState({
          issueDateStart: e
        })
        break;
      case 'issueDateEnd':
        this.setState({
          issueDateEnd: e
        })
        break;
      case 'endDateStart':
        this.setState({
          endDateStart: e
        })
        break;
      case 'endDateEnd':
        this.setState({
          endDateEnd: e
        })
        break;
    }
  }

  selectSortMainType = (e) => {
    this.setState({
      sortMainType: e.target.value || 'dueDate',
      last: null,
      notMore: false,
      dbEstimates2s: [],
      algoriaPage: 1
    }, () => {
      if (this.state.algolia) {
        this.getEstimates2sA(this.props, true, this.state.searchwordA);
      } else {
        this.getEstimates2s(this.props, true);
      }
    });
  }

  handleSearchAmountChange = (e) => {
    this.setState({
      searchAmount: e.currentTarget.value
    })
  }
  handleSearchAmountEndChange = (e) => {
    this.setState({
      searchAmountEnd: e.currentTarget.value
    })
  }
  filterTypeChange = (e) => {
    let value = e.target.value || 'number';
    // console.log('filterType', value);
    let obj = {
      filterType: value
    };
    if (value === 'sender') {
      obj.sender = this.state.sellerUsers[0].user;
    }
    if (value === 'confirmer') {
      obj.confirmer = this.state.buyerUsers[0].user;
    }
    if (value === 'receiver') {
      obj.receiver = this.state.buyerUsers[0].user;
    }
    this.setState(obj)
  }

  estimatesFilter = () => {
    console.log('estimatesFilter filter');
    this.setState({
      algoriaPage: 1,
      notMore: false,
      algolia: true,
      last: null,
      dbEstimates2s: [],
      selectedEstimatesList: [],
    }, () => {
      this.getEstimates2sA(this.props, true,null);
    })
  }

  render() {
    if (!this.props.org) {
      return (
          <>
            取引先を選択してください。
          </>
      )
    }

    let kaigawa = false;
    let urigawa = false;
    if ( (this.props.userOrg && this.props.userOrg.buyer && this.props.org && this.props.org.reseller)
        || (this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.maker)
    ){
      kaigawa = true;
    }
    if ( (this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.buyer)
        || (this.props.userOrg && this.props.userOrg.maker && this.props.org && this.props.org.reseller)
    ){
      urigawa = true;
    }

    if(! kaigawa && ! urigawa){
      return (
          <>
          </>
      )
    }

    const estimates2s = [];

    function n(n){
      return n > 9 ? "" + n: "0" + n;
    }

    this.state.dbEstimates2s.forEach((estimates2,index) => {
      let created, startDate;
      let confirmDate = '';
      let expireDate = '';

      if (this.state.algolia) {
        let cDate = new Date(estimates2['created']._seconds * 1000 + estimates2['created']._nanoseconds/1000000);
        created = cDate.getFullYear() + '/'
            + n(cDate.getMonth()+1) + '/'
            + n(cDate.getDate()) + ' '
            + n(cDate.getHours()) + ":"
            + n(cDate.getMinutes());

        if (estimates2['confirmDate']) {
          let coDate = new Date(estimates2['confirmDate']._seconds * 1000 + estimates2['confirmDate']._nanoseconds/1000000);
          confirmDate = coDate.getFullYear() + '/'
              + n(coDate.getMonth()+1) + '/'
              + n(coDate.getDate()) + ' '
              + n(coDate.getHours()) + ":"
              + n(coDate.getMinutes());
        }

        if (estimates2['date']) {
          let dDate = new Date(estimates2['date']._seconds * 1000 + estimates2['date']._nanoseconds/1000000);
          startDate = dDate.getFullYear() + '/'
              + n(dDate.getMonth()+1) + '/'
              + n(dDate.getDate());
        }

        if (estimates2['expireDate']) {
          let eDate = new Date(estimates2['expireDate']._seconds * 1000 + estimates2['expireDate']._nanoseconds/1000000);
          expireDate = eDate.getFullYear() + '/'
              + n(eDate.getMonth()+1) + '/'
              + n(eDate.getDate());
        }
      } else {
        created = estimates2['created'].toDate().getFullYear() + '/'
            + n(estimates2['created'].toDate().getMonth()+1) + '/'
            + n(estimates2['created'].toDate().getDate()) + ' '
            + n(estimates2['created'].toDate().getHours()) + ":"
            + n(estimates2['created'].toDate().getMinutes());

        if (estimates2['confirmDate']) {
          confirmDate = estimates2['confirmDate'].toDate().getFullYear() + '/'
              + n(estimates2['confirmDate'].toDate().getMonth()+1) + '/'
              + n(estimates2['confirmDate'].toDate().getDate()) + ' '
              + n(estimates2['confirmDate'].toDate().getHours()) + ":"
              + n(estimates2['confirmDate'].toDate().getMinutes());
        }

        if (estimates2['date']) {
          startDate = estimates2['date'].toDate().getFullYear() + '/'
              + n(estimates2['date'].toDate().getMonth()+1) + '/'
              + n(estimates2['date'].toDate().getDate());
        }

        if (estimates2['expireDate']) {
          expireDate = estimates2['expireDate'].toDate().getFullYear() + '/'
              + n(estimates2['expireDate'].toDate().getMonth()+1) + '/'
              + n(estimates2['expireDate'].toDate().getDate());
        }
      }

      let visited = '';
      if(urigawa) {
        if (estimates2['visited'] && estimates2['visited'][estimates2['toUser']] || estimates2['confirmDate']) { //[estimates2['toUser']]
          visited = <>{estimates2['confirmUserName'] && <><span className="text-nowrap">{estimates2['confirmUserName']}</span><br/></>}<MDBChip className="text-nowrap disabled">確認済</MDBChip></>;
        } else {
          visited = <MDBChip bgColor="danger-color" text="white" className="text-nowrap disabled">未確認</MDBChip>;
        }
      }

      if ( kaigawa ){
        if (estimates2['visited'] && estimates2['visited'][this.props.user.id] || estimates2['confirmDate']) { //[this.props.user.id]
          visited = <>{estimates2['confirmUserName'] && <><span className="text-nowrap">{estimates2['confirmUserName']}</span><br/></>}<MDBChip className="text-nowrap disabled">確認済</MDBChip></>;
        } else {
          visited = <MDBChip bgColor="danger-color" text="white" className="text-nowrap disabled">未確認</MDBChip>;
        }
      }

      let bold;
      if (urigawa) {
        bold = estimates2['readSeller'] === false
      }

      if (kaigawa) {
        bold = estimates2['readBuyer'] === false
      }
      let estId = estimates2.objectID ? estimates2.objectID : estimates2.id
      let checked = this.estimatesIsSelected(estId);
      let data = {
        'check':<div style={{width: 50}}> <MDBInput label=" " type="checkbox" checked={checked} id={"checkbox"+index} onChange={(e) => this.estimatesSelect(e.target.checked, estimates2)} /> </div>,
        '見積番号':<span style={{fontWeight: bold ? 'bold' : ''}} className="text-nowrap">{estimates2['number']}<br/>{estimates2['id']}</span>,
        '送信者': <span style={{fontWeight: bold ? 'bold' : ''}} className="text-nowrap">{estimates2['fromUserName']}<br/>{created}</span>,
        '見積受取者': <span style={{fontWeight: bold ? 'bold' : ''}} className="text-nowrap">
          <span><MDBIcon icon="envelope" className="custom-text-grey" style={{marginRight: 5}}/>{estimates2['toUserName']}</span><br/>
          {estimates2['toUserCCName'] && estimates2['toUserCCName'].map(usr => {
            return <><span><MDBIcon icon="users" className="custom-text-grey" style={{marginRight: 5}}/>{usr}</span><br/></>
          })}
        </span>,
        '確認日時': <span>{visited}<br/>{confirmDate}</span>,
        '発行日': <span style={{fontWeight: bold ? 'bold' : ''}} className={'text-nowrap'}>{startDate}<br/>{expireDate}</span>,
        '請求書タイトル': <div style={{fontWeight: bold ? 'bold' : ''}}>{estimates2['title']}<><br/>{(estimates2['totalAmount'] === 0 || estimates2['totalAmount']) && estimates2['totalAmount'].toLocaleString()+"円"}</></div>,
        '詳細': <StorageLink src={estimates2['file']} storage={this.props.storage} target="_blank"><MDBChip bgColor="default-color" text="white" size="sm4" className="text-nowrap" data-id={estimates2.id} data-urigawa={urigawa} data-index={index} onClick={this.openFile} >表示</MDBChip></StorageLink>,
        // '内容表示': <StorageLink src={estimates2['file']} storage={this.props.storage} target="_blank"><MDBChip bgColor="default-color" text="white" size="sm4" className="text-nowrap" data-id={estimates2.id} onClick={this.openFile} >内容表示</MDBChip></StorageLink>,
      };

      if (urigawa) {
        if (estimates2.deleted) {
          data['確認'] = <div style={{textAlign: 'center'}}>
            <MDBChip className="text-nowrap disabled custom-button-gray" style={{margin: '0 auto'}}>削除済</MDBChip>
          </div>
        } else {
          data['確認'] = <div style={{textAlign: 'center'}}>
            <MDBBtn rounded flat size="sm"
                    data-id={estimates2.id}
                    data-title={estimates2['title']}
                    onClick={this.delete}
            >
              <MDBIcon
                  icon="trash"
                  size={'2x'}
                  className="custom-text-grey"/>
            </MDBBtn>
          </div>
        }

      }

      estimates2s.push(data);

    });

    const data = {
      columns: [
        {
          label: <div style={{width: 50}}><MDBInput label=" " type="checkbox" id="checkboxAll" onChange={(e) => this.estimatesSelectAll(e.target.checked)} /></div>,
          field: 'check',
          sort: 'asc',
          width: 50
        },
        {
          label: <div><row>見積番号</row><br/><row>見積書ID</row></div>,
          field: '見積番号',
          sort: 'asc',
          width: 80,
          minimal: 'sm'
        },
        {
          label: <div><row>送信者</row><br/><row>送信日時</row></div>,
          field: '送信者',
          sort: 'asc',
          width: 80,
          minimal: 'sm'
        },
        {
          label: '見積受取者',
          field: '見積受取者',
          sort: 'asc',
          width: 80,
          minimal: 'sm'
        },
        {
          label: <div><row>見積書確認者</row><br/><row>確認日時</row></div>,
          field: '確認日時',
          sort: 'disabled',
          width: 80,
          minimal: 'sm'
        },
        {
          label: <div><row>発行日</row><br/><row>有効期限</row></div>,
          field: '発行日',
          sort: 'asc',
          width: 80,
          minimal: 'sm'
        },
        {
          label: <div><row>見積書タイトル</row><br/><row>税込合計金額（円）</row></div>,
          field: '見積書タイトル',
          sort: 'disabled',
          width: 370,
          minimal: 'sm'
        },
        {
          label: '詳細',
          field: '詳細',
          sort: 'disabled',
          width: 50,
          minimal: 'sm'
        }
      ],
      rows: estimates2s
    }

    if(urigawa) {
      data.columns.push({
        label: <div style={{textAlign: 'center'}}>削除</div>,
        field: '削除',
        sort: 'disabled',
        width: 50,
        minimal: 'sm'
      });
    }

    let selectOption = <>
      <option value={1}>送信済一覧</option>
      <option value={2}>削除済一覧</option>
      <option value={3}>すべて</option>
    </>

    return (
      <>
      <h2>見積書一覧</h2>
        <div style={{display:'flex',flexDirection:'column',flex:1,justifyContent:'flex-start'}}>
          <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-end'}}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10}}>
                <div style={{margin:0}}>
                  <select style={{height:'38px'}} className="browser-default custom-select" value={this.state.filterType} onChange={(e) => this.filterTypeChange(e)}>
                    <option value={'estimateNo'}>見積番号</option>
                    <option value={'estimateId'}>見積書ID</option>
                    <option value={'sender'}>送信者</option>
                    <option value={'sentDate'}>送信日時</option>
                    <option value={'receiver'}>見積受取者</option>
                    <option value={'confirmer'}>見積確認者</option>
                    <option value={'confirmDate'}>確認日時</option>
                    <option value={'amount'}>税込合計金額</option>
                    <option value={'issueDate'}>発行日</option>
                    <option value={'endDate'}>有効期限</option>
                    <option value={'title'}>見積タイトル</option>
                  </select>
                </div>
                {this.state.filterType === 'issueDate' &&
                    <div style={{flex: 1, display: 'flex', alignItems: 'center', width: 418,height:'38px'}}>
                      <div className="d-md-flex flex-row mt-0 align-items-center">
                        <DatePicker
                            dateFormat={"yyyy/MM/dd"}
                            id={"issueDate"}
                            className={"form-control"}
                            selected={this.state.issueDateStart}
                            onChange={(e) => this.handleChange(e,'issueDateStart')}
                            locale={"ja-JP"}
                        />
                        <div className="p-2">〜</div>
                        <DatePicker
                            dateFormat={"yyyy/MM/dd"}
                            id={"issueDate"}
                            className={"form-control"}
                            selected={this.state.issueDateEnd}
                            onChange={(e) => this.handleChange(e,'issueDateEnd')}
                            locale={"ja-JP"}
                        />
                      </div>
                    </div>
                }
                {this.state.filterType === 'endDate' &&
                    <div style={{flex: 1, display: 'flex', alignItems: 'center', width: 418,height:'38px'}}>
                      <div className="d-md-flex flex-row mt-0 align-items-center">
                        <DatePicker
                            dateFormat={"yyyy/MM/dd"}
                            id={"endDate"}
                            className={"form-control"}
                            selected={this.state.endDateStart}
                            onChange={(e) => this.handleChange(e,'endDateStart')}
                            locale={"ja-JP"}
                        />
                        <div className="p-2">〜</div>
                        <DatePicker
                            dateFormat={"yyyy/MM/dd"}
                            id={"endDate"}
                            className={"form-control"}
                            selected={this.state.endDateEnd}
                            onChange={(e) => this.handleChange(e,'endDateEnd')}
                            locale={"ja-JP"}
                        />
                      </div>
                    </div>
                }
                {this.state.filterType === 'sentDate' &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <div className="d-md-flex flex-row mt-0 align-items-center">
                        <DatePicker
                            dateFormat={"yyyy/MM/dd"}
                            id={"sentDate"}
                            className={"form-control"}
                            selected={this.state.sentDateStart}
                            onChange={(e) => this.handleChange(e,'sentDateStart')}
                            locale={"ja-JP"}
                        />
                        <div className="p-2">〜</div>
                        <DatePicker
                            dateFormat={"yyyy/MM/dd"}
                            id={"sentDate"}
                            className={"form-control"}
                            selected={this.state.sentDateEnd}
                            onChange={(e) => this.handleChange(e,'sentDateEnd')}
                            locale={"ja-JP"}
                        />
                      </div>
                    </div>
                }
                {this.state.filterType === 'confirmDate' &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <div className="d-md-flex flex-row mt-0 align-items-center">
                        <DatePicker
                            dateFormat={"yyyy/MM/dd"}
                            id={"confirmDate"}
                            className={"form-control"}
                            selected={this.state.confirmDateStart}
                            onChange={(e) => this.handleChange(e,'confirmDateStart')}
                            locale={"ja-JP"}
                        />
                        <div className="p-2">〜</div>
                        <DatePicker
                            dateFormat={"yyyy/MM/dd"}
                            id={"confirmDate"}
                            className={"form-control"}
                            selected={this.state.confirmDateEnd}
                            onChange={(e) => this.handleChange(e,'confirmDateEnd')}
                            locale={"ja-JP"}
                        />
                      </div>
                    </div>
                }
                {(this.state.filterType === 'estimateNo') &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <input
                          className="form-control my-0 py-1"
                          type="text"
                          placeholder=""
                          aria-label=""
                          onChange={(e) => this.handleChange(e,'estimateNo')}
                          value={this.state.estimateNo}
                      />
                    </div>
                }
                {(this.state.filterType === 'estimateId') &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <input
                          className="form-control my-0 py-1"
                          type="text"
                          placeholder=""
                          aria-label=""
                          onChange={(e) => this.handleChange(e,'estimateId')}
                          value={this.state.estimateId}
                      />
                    </div>
                }
                {this.state.filterType === 'amount' &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <div className="d-md-flex flex-row mt-0 align-items-center">
                        <input
                            className="form-control my-0 py-1"
                            type="number"
                            placeholder=""
                            aria-label=""
                            onChange={this.handleSearchAmountChange}
                            value={this.state.searchAmount}
                        />
                        <div className="p-2">〜</div>
                        <input
                            className="form-control my-0 py-1"
                            type="number"
                            placeholder=""
                            aria-label=""
                            onChange={this.handleSearchAmountEndChange}
                            value={this.state.searchAmountEnd}
                        />
                      </div>
                    </div>
                }
                {(this.state.filterType === 'title') &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <input
                          className="form-control my-0 py-1"
                          type="text"
                          placeholder=""
                          aria-label=""
                          onChange={(e) => this.handleChange(e,'title')}
                          value={this.state.title}
                      />
                    </div>
                }
                {this.state.filterType === 'sender' &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <select className="browser-default custom-select" value={this.state.sender} onChange={(e) => this.handleChange(e,'sender')}>
                        {this.state.sellerUsers.map((user) => {
                          return <option value={user.user}>{user.name}</option>
                        })}
                      </select>
                    </div>
                }
                {this.state.filterType === 'confirmer' &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <select className="browser-default custom-select" value={this.state.confirmer} onChange={(e) => this.handleChange(e,'confirmer')}>
                        {this.state.buyerUsers.map((user) => {
                          return <option value={user.user}>{user.name}</option>
                        })}
                      </select>
                    </div>
                }
                {this.state.filterType === 'receiver' &&
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, width: 418,height:'38px'}}>
                      <select className="browser-default custom-select" value={this.state.receiver} onChange={(e) => this.handleChange(e,'receiver')}>
                        {this.state.buyerUsers.map((user) => {
                          return <option value={user.user}>{user.name}</option>
                        })}
                      </select>
                    </div>
                }
                <div>
                  <MDBBtn
                      color="default"
                      type="submit"
                      style={{width: '90px', margin: 0, height: 38, padding: '0.64rem 1.14rem'}}
                      onClick={this.estimatesFilter}
                  >検　索</MDBBtn>
                </div>
              </div>
            </div>
          </div>
          <div style={{display:'flex',flexDirection:'row',flex:1,justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <MDBBtn size={'sm'} color="default" style={{padding: 10, height: 38, width: 200,margin:0}}  disabled={this.state.selectedEstimatesList.length > 0 ? this.state.downloading : true} onClick={() => this.downloadSelectedEstimates()}>
                {this.state.downloading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight: 10}}/>}
                {!this.state.downloading && <MDBIcon icon="download" style={{marginRight: 10}} />}
                選択したPDF一括ダウンロード
              </MDBBtn>
            </div>
            <div style={{alignItems: 'center',color: '#495057',display:'flex',justifyContent:'flex-end',flexDirection:'row'}}>
              <div style={{margin: 0,width:204}}>
                <select style={{height:'38px'}} className="browser-default custom-select" value={this.state.sortMainType} onChange={(e) => this.selectSortMainType(e)}>
                  <option value={'dueDate'}>発行日順で並べ替え</option>
                  <option value={'expireDate'}>有効期限で並べ替え</option>
                  <option value={'created'}>送信日時で並べ替え</option>
                </select>
              </div>
              <div className="form-check form-check-inline" style={{marginLeft: 10}}>
                <input type="radio" className="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
                       checked={this.state.sortType === 'asc'} onClick={() => this.sortChange('asc')}/>
                <label className="form-check-label" htmlFor="materialInline1">昇順</label>
              </div>

              <div className="form-check form-check-inline">
                <input type="radio" className="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
                       checked={this.state.sortType === 'desc'} onClick={() => this.sortChange('desc')}/>
                <label className="form-check-label" htmlFor="materialInline2">降順</label>
              </div>

              {
                  urigawa && <>
                    <div className="form-check form-check-inline" style={{marginLeft: 20}}>
                      表示
                    </div>

                    <div className="form-check form-check-inline">
                      <select className="browser-default custom-select" value={this.state.estimates2sType} onChange={(e) => this.selectEstimates2sType(e)}>
                        {selectOption}
                      </select>
                    </div>
                  </>
              }

              <div >
                <MDBBtn
                    color="default" style={{width: '90px', height: 38, padding: '0.64rem 1.14rem',marginRight:0}} flat={true} outline={true} onClick={() => this.clearFilter()}>
                  リセット
                </MDBBtn>
              </div>
            </div>
          </div>
        </div>

        <div id="wrapper1" style={{height: 20, overflow: 'auto'}}>
          <div id="div1" style={{height: 20}}>
          </div>
        </div>
      <MDBTable responsive btn small id={"div2"}>
        <MDBTableHead color="primary-color" textWhite columns={data.columns} />
        <MDBTableBody rows={data.rows} />
      </MDBTable>
      {this.state.loading && <div className="d-flex justify-content-center mt-5"><MDBSpinner /></div>}

        <MDBModal isOpen={this.state.deleteModal} toggle={this.deleteClose}>
          <MDBModalHeader toggle={this.deleteClose}>見積書削除</MDBModalHeader>
          <MDBModalBody>
            見積書「{this.state.deleteTitle}」を削除します。よろしいですか？
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn onClick={this.deleteClose} color="secondary">キャンセル</MDBBtn>
            <MDBBtn onClick={this.deleteClose} color="danger" data-id={this.state.deleteId}>削除</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </>
    )

  }
}

export default Estimates2TableList;
